// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

axios.defaults.showLoading = true;

Vue.prototype.$axios = axios
Vue.config.productionTip = false


// http request 拦截器
axios.interceptors.request.use(
    config => {
        // 如果本地存储中有token字段， 就为所有请求加上Authorization请求头
        if (localStorage.token != undefined) {
            config.headers["Authorization"] = localStorage.token;
        }
        if (config.showLoading) {
            startLoading()
        }
        return config;
    },
    error => {
        console.log(error)      // for debug
        Promise.reject(error)
    }
)

// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.config.showLoading) {
            endLoading()
        }
        return response
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                // 如果后端返回没有权限
                case 401:
                    // 清除token信息并跳转到登录页面
                    localStorage.clear();
                    router.replace("/");
            }
        }
        if (error.response.config.showLoading) {
            endLoading()
        }
        return Promise.reject(error)    // 返回接口返回的错误信息
    }
)


import {Loading} from 'element-ui'

let loading;

function startLoading() {
    loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}

function endLoading() {
    loading.close()
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js